// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// imports
import { Layout } from './layout.component';
import { LayoutSection } from './layout-section.component';

@NgModule({
  declarations: [
    Layout,
    LayoutSection,
  ],
  exports: [
    Layout,
    LayoutSection,
  ],
  imports: [
    CommonModule,
  ]
})
class LayoutModule { }

export { Layout, LayoutSection, LayoutModule };
